export default {
  strict: true,
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    // navItems (state, getters) {
    //   return state.items
    // }
  },
  actions: {
    addToNav ({ commit }, newItem) {
      if (newItem.to && newItem.label) {
        commit('addNavItem', newItem)
      } else {
        console.log('Can\'t add new nav item object: its missing either "to" or "label"')
      }
    }
  },
  mutations: {
    addNavItem (state, newItem) {
      state.items.push(newItem)
    }
  }
}
